import { Box, Loader } from '@mantine/core';

type ListLoaderProps = {
  height?: string;
};

export const ListLoader = ({ height = 'calc(100vh - 105px)' }: ListLoaderProps) => {
  return (
    <Box
      style={{
        display: 'flex',
        height,
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Loader size="xl" />
    </Box>
  );
};
